import React from "react";
import { InventoryStats as Stats } from "../../../utils/inventoryStats";

interface InventoryStatsProps {
  stats?: Stats;
  isLoading: boolean;
}

// Compact Indian-style currency (₹1.2L, ₹3.4Cr) so big values fit on mobile.
const formatCurrency = (value: number): string => {
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      notation: "compact",
      maximumFractionDigits: 1,
    }).format(value);
  } catch {
    return `₹${value.toLocaleString("en-IN")}`;
  }
};

const formatNumber = (value: number): string => value.toLocaleString("en-IN");

export const InventoryStats: React.FC<InventoryStatsProps> = ({ stats, isLoading }) => {
  const cards = [
    { label: "Total products", value: stats ? formatNumber(stats.totalProducts) : "—", valueClass: "text-slate-900" },
    {
      label: "Inventory value",
      value: stats ? formatCurrency(stats.inventoryValue) : "—",
      title: stats ? `₹${formatNumber(stats.inventoryValue)}` : undefined,
      valueClass: "text-slate-900",
    },
    { label: "Low stock", value: stats ? formatNumber(stats.lowStock) : "—", valueClass: stats && stats.lowStock > 0 ? "text-amber-600" : "text-slate-900" },
    { label: "Out of stock", value: stats ? formatNumber(stats.outOfStock) : "—", valueClass: stats && stats.outOfStock > 0 ? "text-rose-600" : "text-slate-900" },
  ];

  // Borderless stat strip — divided by whitespace, not boxes.
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-5 sm:gap-x-10 mb-8">
      {cards.map((card) => (
        <div key={card.label}>
          <p className="text-xs font-medium text-slate-500">{card.label}</p>
          {isLoading && !stats ? (
            <div className="h-7 w-20 bg-slate-200 rounded animate-pulse mt-1.5" />
          ) : (
            <p className={`mt-1 text-2xl font-bold tracking-tight ${card.valueClass}`} title={card.title}>
              {card.value}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};
